import SelectionOfSuppliersSearchResult from './SuppliersSearchResult';

export default SelectionOfSuppliersSearchResult;
